module.exports = __webpack_public_path__ + "img/sindre.85a60509.jpg";